import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Notification } from '@contently/toolkit';
import { US, CANADA, US_AND_CANADA, digitFormatter } from './utils';
import FilterContext from './FilterContext';

const Benchmark = styled('span')`
  color: ${({ value }) => {
    if (value === 0) {
      return 'black';
    }
    if (value > 0) {
      return 'green';
    }
    if (value < 0) {
      return 'red';
    }
  }};
`;

const valueFormatter = (value, type) => {
  if (type === 'traffic') {
    if (value < 0) {
      return `-$${digitFormatter(Math.abs(value))}`;
    }
    return `$${digitFormatter(value)}`;
  }
  return value;
};

const hoverBenchmark = (value, type) => {
  if (value === null) return null;
  return (
    <span>
      <Benchmark value={value}>
        {value >= 0 && '+'}
        {valueFormatter(value, type)}
      </Benchmark>{' '}
      from last month
    </span>
  );
};

const trafficDiffFilter = (trafficDiffObj, region) => {
  if (!trafficDiffObj) return null;
  if (region === US_AND_CANADA) {
    return trafficDiffObj.all;
  }
  if (region === US) {
    return trafficDiffObj.us;
  }
  if (region === CANADA) {
    return trafficDiffObj.canada;
  }
  return null;
};

// eslint-disable-next-line react/prop-types
const ContentValTooltip = ({ active, payload, label }) => {
  const filter = useContext(FilterContext);

  if (active && payload && payload.length) {
    if (payload[0].payload.month === 'No data available - please add published URLS') {
      return null;
    }
    const storiesDiff = payload[0].payload.stories_published_diff;
    const trafficDiff = payload[0].payload.traffic_value_diff;
    const trafficDiffValueByReg = trafficDiffFilter(trafficDiff, filter);
    const message = (
      <div>
        <p>
          {payload[0].payload.lineDataLabel} {hoverBenchmark(trafficDiffValueByReg, 'traffic')}
        </p>
        <p>
          {payload[0].value} stories {hoverBenchmark(storiesDiff)}
        </p>
      </div>
    );

    return (
      <Notification
        headline={label}
        message={message}
        onAccept={() => {}}
        onDecline={() => {}}
        showDeclineMsg
        declineComponent
      />
    );
  }
  return null;
};

export default ContentValTooltip;

ContentValTooltip.defaultProps = {
  payload: null
};

ContentValTooltip.propTypes = {
  payload: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({
      month: PropTypes.string,
      lineData: PropTypes.number,
      lineDataLabel: PropTypes.string,
      barData: PropTypes.number,
      length: PropTypes.number
    })
  ])
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/content_val_tooltip.jsx